<template>
  <div class="container">
	<b-row>
		<b-col cols="12" class="p-0">
			<!-- <div>
				<Slider v-if="params['slider_items'] >= 3" v-bind:items="params['slider_items']" v-bind:settings="slider_settings" v-bind:page="'investors'"></Slider>
			</div> -->
			<div class="container">
				<b-row class="static-slider-wrapper">
					<b-col cols="12" class="pl-1 pr-1 pl-lg-0 pr-lg-0 mr-lg-1 ml-lg-1 d-inline-block text-left">
						<div class="border-slide d-inline-block text-center m-1" v-for="(item, idx) in params['slider_items']" :key="idx">
							<a :href="item.href" target="_blank" class="investors-selected d-block h-100">
								<div class="inner-slide up position-relative h-50 pt-1">
									<p class="section-title mb-1" :style="(item.name.length > 24) ? 'font-size: 8px; line-height: 12px;' : ''">{{item.name}}</p>
									<div class="position-absolute w-100 year-label">
										<hr class="m-0 mx-auto w-25">
										<p class="section-title mt-1 m-0" :style="(item.name.length > 33) ? 'font-size: 8px; line-height: 12px;' : ''">{{item.year}}</p>
									</div>
								</div>
								<div class="inner-slide down h-50 pt-3 text-white section-title">
									<div class="ani_icon text-center slider-down">
					                    <div class="slide-1">
					                        <img class="d-inline-block" alt="Seta_Download_3.png" src="../../assets/images/Seta_Download_4.png">
					                    </div>
					                    <div class="slide-2">
											<img class="d-inline-block" alt="Seta_Download_3.png" src="../../assets/images/Seta_Download_4.png">
										</div>
					                </div>
									<p class="m-0 position-relative">
										<span class="pt-0 d-block">DOWNLOAD PDF</span>
									</p>
								</div>
							</a>
						</div>
					</b-col>
				</b-row>
			</div>
		</b-col>
  	</b-row>
  </div>
</template>
<script>
// import Slider from '@/components/Slider.vue'

export default {
	name: 'general_meeting',
	components: {
		// Slider
	},
	props: ['params'],
	data() {
		return {
			current_slide: 0,
			/*slider_settings: {
				mouseDrag: false,
				shortDrag: false, // so it won't slide on mobile screen just by touching it
				transition: 600,
				wheelControl: false,
				initialSlide: 0,
				infiniteScroll: true,
				centerMode: false,
				itemsToSlide: 1,
				breakpoints: {
		            0: {
		              itemsToShow: 3,
		              // centerMode: false,
		              // pagination: 'indicator'
		            },
		            991.98: {
					  itemsToShow: 3
		              // pagination: 'fraction'
		            },
					1200: {
					  itemsToShow: 3
					}
	          	}
	        }*/
		}
	}
	/*created() {
		console.log(this.params);
	}*/
}
</script>
<style scoped>
.static-slider-wrapper .border-slide {
	height: 140px;
	width: 26.2%;
}
.static-slider-wrapper a {
	color: inherit;
}
.static-slider-wrapper .border-slide {
	border: 2px solid rgb(0, 38, 61);
}
.static-slider-wrapper .border-slide hr {
	background-color: #00263d;
	border-top: none;
	height: 3px;
}
.static-slider-wrapper .border-slide .year-label {
	left: 0;
	bottom: 1px;
}
.static-slider-wrapper .border-slide .up p {
	line-height: 18px;
	font-size: 12px;
}
.static-slider-wrapper .border-slide .down p {
	font-size: 9px;
	top: -4px;
}
.static-slider-wrapper .border-slide .inner-slide {
	/*transition: background-color 0.25s ease-in-out;*/
}
.static-slider-wrapper .border-slide .inner-slide.up {
	background-color: rgba(255, 255, 255, 0.7);
}
.static-slider-wrapper .border-slide .inner-slide.down {
	background-color: rgba(0, 38, 61, 0.7);
}
.static-slider-wrapper .border-slide .investors-selected .inner-slide.up {
	background-color: rgba(255, 255, 255, 1);
}
.static-slider-wrapper .border-slide .investors-selected .inner-slide.down {
	background-color: rgba(0, 38, 61, 1);
}


.ani_icon {
	    display: inline-block;
	    position: relative;
		width: 100%;
	    height: 25px;
	    overflow: hidden;
	    cursor: pointer;
	}
	.slide-1 {
	    position: absolute;
	    top:-3px; left:0;
	    height: 100%;
	    width: 100%;
	    transition: all .5s;
	}
	img {
		width: 19px;
	}
	.static-slider-wrapper .border-slide:hover .ani_icon.slider-down .slide-1 { top: 100%; opacity:0; }

	.slide-2 {
	    position: absolute;
	    height: 100%;
	    width: 100%;
	    font-size: 1.2em;
	    transition: all .5s;
	    opacity: 0;
	}

	.ani_icon.slider-down .slide-2 { top: -100%; }


	.static-slider-wrapper .border-slide:hover .ani_icon.slider-down .slide-2 { top:-3px; opacity: 1; }


@media screen and (max-width:1200px) {
	.static-slider-wrapper .border-slide {
		
	}
}
@media screen and (max-width:991.98px) {
	.static-slider-wrapper .border-slide {
		width: 32.5%
	}
}
@media screen and (max-width:767.98px) {
	.static-slider-wrapper .border-slide {
		
	}
}

</style>